export default __webpack_public_path__ + "static/media/shipboardBox.0ff4c1d1.png";